import { StorageNamesEnum } from "@ch/helpers/utils/enums";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import localforage from "localforage";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import postChatStream from "../utils/postChatStream";

export const warmUpMessageId = "ad2068b7-3210-4f3d-acd7-444989636a97";

const useKemWarmUp = () => {
  const user = useAppSelector((state) => state.user?.currentUser);
  const kemResponseLanguage = useAppSelector(
    (state) => state.kem.responseLanguage,
  );

  useEffect(() => {
    const handleWarmUp = async () => {
      const refreshToken = await localforage.getItem<string>(
        StorageNamesEnum.REFRESH_TOKEN,
      );
      const headers: Record<string, string> = {
        accept: "*/*",
        "Content-Type": "application/json",
      };
      if (refreshToken) headers["X-Token"] = refreshToken;

      const body: Record<string, unknown> = {
        user_full_name: user?.name?.trim() ?? "User",
        user_id: user?.id,
        sender_enum: "user",
        message: warmUpMessageId,
        created_at: new Date().toISOString(),
        modified_at: new Date().toISOString(),
        is_output_audio: false,
        id: uuidv4(),
        language_preference: kemResponseLanguage,
      };

      postChatStream({
        body,
        headers,
        suppressErrors: true,
        onLoading: () => {},
        onUpdateChunk: () => {},
        onComplete: () => {},
      });
    };

    void handleWarmUp();
  }, [kemResponseLanguage, user?.id, user?.name]);
};

export default useKemWarmUp;
